import React, { useEffect } from 'react'

import { DeleteButtonRenderer } from '@app/components/renderers'

import type { useRemoveTableRowButtonParams } from './types'

export const useRemoveTableRowButton = <DataSource extends { key: string | number }>({
  columns,
  onClick
}: useRemoveTableRowButtonParams<DataSource>): void => {
  useEffect(() => {
    const column = columns.find(columnRow => columnRow.key === 'removeButton')

    if (column) {
      column.render = (_, record) => (
        <DeleteButtonRenderer
          rowKey={ record.key }
          onClick={ key => onClick(key) }
        />
      )
      column.sorter = false
    }
  }, [columns])
}
